import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import { videoProductToRoute } from 'helper/videos';
import { cssVar } from 'constants/theme';
import { VideoCardProps } from '../VideoCard';

export default function VideoGridCard({
  data,
  product,
  isAdminView,
  onEdit,
  onDelete,
}: VideoCardProps) {
  const navigate = useNavigate();
  const productRoute = videoProductToRoute[product];
  const date = new Date(data.uri.release_time).toLocaleDateString('pt-BR');

  return (
    <div
      className="videos-mobile-grid-card"
      role="button"
      tabIndex={0}
      onClick={() => navigate(`${productRoute}/${data.id}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') navigate(`${productRoute}/${data.id}`);
      }}
    >
      <div className="videos-mobile-grid-thumb">
        <img src={data.uri.pictures?.base_link} alt={data.titulo} />
      </div>
      <div className="videos-mobile-grid-body">
        <span className="videos-mobile-card-date">{date}</span>
        <h3 className="videos-mobile-grid-title">{data.titulo}</h3>
        {isAdminView && (
          <div className="videos-mobile-card-actions">
            <button
              type="button"
              aria-label="Editar vídeo"
              className="videos-mobile-card-action filled"
              onClick={(event) => {
                event.stopPropagation();
                onEdit(data.id);
              }}
            >
              <Icon iconType="edit" color={cssVar('text-on-accent')} size="small" />
            </button>
            <button
              type="button"
              aria-label="Excluir vídeo"
              className="videos-mobile-card-action light"
              onClick={(event) => {
                event.stopPropagation();
                onDelete(data);
              }}
            >
              <Icon iconType="trash" color={cssVar('text-strong')} size="small" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
